<template>
  <div class="lesson-title-wrap">
    <span class="num">第{{ getInfo.num }}讲</span>
    <span class="corse-name">&nbsp;&nbsp;
      {{ getInfo.name }}
    </span>
    <span class="lesson-tag" v-if="[1,2].includes(getInfo.tag)">
      {{ getInfo.tag == 1 ? '期中' : getInfo.tag == 2 ? '期末' : null }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    getInfo() {
      return this.info
    }
  }
}
</script>
<style lang="less">
.lesson-title-wrap {
  display: flex;
  .num {
    max-width: 90px;
    white-space: nowrap;
  }
  .corse-name {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  .lesson-tag {
    display: inline-block;
    height: 22px;
    color: #fff;
    background: red !important;
    font-size: 12px;
    padding: 2px;
    border-radius: 4px;
    word-break: keep-all;
    margin-left: 8px;
  }
}
</style>